import { array, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const StepProgressBarProperties = {
    allStepsStatus: {
        defaultValue: [],
        type: array,
    },
    leftText: {
        defaultValue: '0/0',
        type: string,
    }
};
export { StepProgressBarProperties, };
//# sourceMappingURL=step-progress-bar-types.js.map